import { Role } from './Role';
import { Type } from 'class-transformer';

export class Permission {
  private id!: number;

  private name!: string;

  private permission!: string;

  @Type(() => Role)
  private roles!: Role[];

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    return this.name;
  }

  public getPermission(): string {
    return this.permission;
  }

  public getRoles(): Role[] {
    return this.roles;
  }

  public hasRole(role: Role): boolean {
    return this.roles.some((item: Role) => item.getId() === role.getId());
  }

  public isAccess(roles: Role[]): boolean {
    return roles.some((role) => this.hasRole(role));
  }

  public setRoles(roles: Role[]): void {
    this.roles = roles;
  }

  public is(permission: string): boolean {
    return this.permission === permission;
  }
}
